<template>
  <div>
    <div class="tenders-table">
      <div class="container">
        <div class="table-tools">
          <div class="tabs-wrapper">
            <button
              class="btn tab-btn"
              :class="{ 'main-btn': tendersDataUrlOptions.status === 'active' }"
              @click="tendersDataUrlOptions.status = 'active'; getTendersData()"
            >
              Ակտիվ
            </button>
            <button
              class="btn tab-btn"
              :class="{ 'main-btn': tendersDataUrlOptions.status === 'archive' }"
              @click="tendersDataUrlOptions.status = 'archive'; getTendersData()"
            >
              Ավարտված
            </button>
          </div>
          <div class="search-box">
            <input v-model="tendersDataUrlOptions.query" @keyup.enter="getTendersData" type="text" placeholder="Որոնել" class="main-inp search-inp">
            <div class="icon-wrapper" @click="getTendersData">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.9304 17.7778L15.5971 14.4444C17.3749 12.1111 17.1527 8.88889 15.0416 6.77778C13.9304 5.55556 12.486 5 10.9304 5C9.37489 5 7.93045 5.55556 6.81934 6.77778C4.486 9.11111 4.486 12.7778 6.81934 15.1111C7.93045 16.2222 9.486 16.8889 10.9304 16.8889C12.1527 16.8889 13.3749 16.4444 14.486 15.6667L17.8193 19L18.9304 17.7778ZM7.93045 13.8889C7.15267 13.1111 6.70822 12 6.70822 10.8889C6.70822 9.77778 7.15267 8.66667 7.93045 7.88889C8.70822 7.11111 9.81934 6.66667 10.9304 6.66667C12.0416 6.66667 13.1527 7.11111 13.9304 7.88889C15.5971 9.55556 15.5971 12.2222 13.9304 13.8889C13.1527 14.6667 12.0416 15.1111 10.9304 15.1111C9.81934 15.1111 8.70822 14.6667 7.93045 13.8889Z" fill="#595E6B"/>
              </svg>
            </div>
          </div>
        </div>
        <div class="tender-data">
          <div class="tender-row heading">
            <div class="inner-content">
              <div class="cell">Անվանում</div>
              <div class="cell">Ծածկագիր</div>
              <div class="cell">Սկիզբ/ավարտ</div>
              <div class="cell">Մրցույթի հայտ և հրավեր</div>
            </div>
          </div>

          <div class="tender-row" v-for="row in tableData" :key="row.id">
            <div class="inner-content">
              <div class="cell name">{{ row.title }}</div>
              <div class="cell password">{{ row.password }}</div>
              <div class="cell date">
                <span class="date-styles">{{$moment(new Date(row.opening_date.replace(/-/g, "/"))).format('DD-MM-YYYY')}} - <br/><b >{{$moment(new Date(row.end_date.replace(/-/g, "/"))).format('DD-MM-YYYY HH:mm')}}</b></span>
              </div>
              <div class="cell action">
                <button class="btn main-btn">Ուղարկել հայտ</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-pagination
      v-if="pagination.totalPages > 1"
      class="justify-content-center"
      :page-count="pagination.totalPages"
      @input="handlePageChange"
      v-model="tendersDataUrlOptions.page"
      :classes="{
        ul: 'pagination', li: 'page-item', liActive: 'page-item-active',
        liDisable: 'disabled btn-disabled', button: 'btn'
        }"
      :labels="{ first: false, prev: 'Հետ', next: 'Առաջ', last: false }"
    />
  </div>
</template>
<script>

import vPagination from 'vue-plain-pagination'

export default {
  components: { vPagination },
  props: ['brandCode'],
  data(){
    return{
      tendersDataUrl: `${process.env.VUE_APP_API_URL}tender/branded`,
      tendersDataUrlOptions: {
        orgCode: this.brandCode,
        index: 1, // for common filters (not user specific)
        status: 'active',
        page: 1,
        limit: 10,
        query: '',
      },
      tableData: {},
      pagination: {
        totalPages: 0
      },
    }
  },
  mounted() {
    this.getTendersData()
  },
  methods: {
    getTendersData() {
      $client.get(this.tendersDataUrl, { params: this.tendersDataUrlOptions }).then(({ data }) => {
        this.tableData = data.data
        this.pagination.totalPages = Math.ceil(data.count / this.tendersDataUrlOptions.limit)
      })
    },
    handlePageChange(page) {
      if (page) {
        this.tendersDataUrlOptions.page = page
        this.getTendersData()
      }
    }
  }
}

</script>
